/**
 * Per-locale public-pricing HTML wrappers set `window.I18N_MANUAL_LANG`
 * before our bundle runs. Wrap the read so the cast lives in one place
 * and call sites stay type-safe.
 */
export function getManualI18nLang() {
  return window.I18N_MANUAL_LANG;
}